import { render } from "./CreatePlaylist.vue?vue&type=template&id=31e0beb2&scoped=true"
import script from "./CreatePlaylist.vue?vue&type=script&lang=js"
export * from "./CreatePlaylist.vue?vue&type=script&lang=js"

import "./CreatePlaylist.vue?vue&type=style&index=0&id=31e0beb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31e0beb2"

export default script